import { gql, useMutation } from '@apollo/client'
import { Jus_Ia_Prompt_Id, Jus_Ia_Template_Id } from '@jusbrasil-web/shared-apollo-client/types'

import {
  JusIaCreateThreadAndSaveMessagesMutation,
  JusIaCreateThreadAndSaveMessagesMutationVariables,
} from './__generated__/use-jusia-context.graphql'
import { JusIaContextProps } from './types'

export interface createThreadWithContextProps {
  context: JusIaContextProps
  promptId?: string
  templateId: string
}

interface UseJusiaContextOutput {
  called: boolean
  isLoading: boolean
  createThreadWithContext: (props: createThreadWithContextProps) => Promise<string | null>
}

export const JUSIA_MUTATION = gql`
  mutation jusIaCreateThreadAndSaveMessages($input: JusIaCreateThreadAndSaveMessagesInput!) {
    jusIaCreateThreadAndSaveMessages(input: $input) {
      thread {
        id
      }
    }
  }
`

export function useJusiaContext(pid: number): UseJusiaContextOutput {
  const [jusIaCreateThreadAndSaveMessages, { loading: isLoading, called }] = useMutation<
    JusIaCreateThreadAndSaveMessagesMutation,
    JusIaCreateThreadAndSaveMessagesMutationVariables
  >(JUSIA_MUTATION)
  const createThreadWithContext = async ({
    context,
    promptId,
    templateId,
  }: createThreadWithContextProps) => {
    const response = await jusIaCreateThreadAndSaveMessages({
      variables: {
        input: {
          resourceId: String(pid),
          context,
          promptId: promptId as Jus_Ia_Prompt_Id | undefined,
          templateId: templateId as Jus_Ia_Template_Id,
        },
      },
    })
    return response.data?.jusIaCreateThreadAndSaveMessages?.thread?.id ?? null
  }

  return { called, isLoading, createThreadWithContext }
}
